export default {
    LOGIN: 'login:login',
    LOGOUT: 'login:logout',
    redirectToReferrer: 'login:redirectToReferrer',
    isAuthenticated: 'login:isAuthenticated',
    GETDUTY: 'login.duty',
};



// WEBPACK FOOTER //
// ./pages/login/constant.js